// import { lastDayOfMonth, sysdate, systime } from './utils'

export class ContractUtils {
    static instance: ContractUtils
    utils: any = null

    constructor(utils: any) {
        if (ContractUtils.instance) {
            return ContractUtils.instance
        }

        this.utils = utils

        ContractUtils.instance = this
        return this
    }

    anteilSollVarianteVisible = (vertragsendeTyp: any, contractEnd: any, optionContractEnd: any) => {
        return (vertragsendeTyp !== 1 && this.utils.lastDayOfMonth(contractEnd) !== contractEnd) || (vertragsendeTyp === 1 && this.utils.lastDayOfMonth(optionContractEnd) !== optionContractEnd)
    }

    archivTitelDefault = () => `Vertragsschreiben ${this.utils.sysdate()} ${this.utils.systime()}`

    resetAnteilSollVarianteVisibility = (contractEnd: any) => {
        return this.utils.lastDayOfMonth(contractEnd) !== contractEnd
    }
}
